// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestId } from './Harvest';
import { harvestOperationId } from './HarvestOperation';
import { harvestProtocolOpBatchDefinitionId } from './HarvestProtocolOpBatchDefinition';
import { batchTypeEnum } from './BatchTypeEnum';
import { invLocationId } from './InvLocation';
import { batchStatusEnum } from './BatchStatusEnum';
import { batchClearanceDefinitionId } from './BatchClearanceDefinition';
import { batchClearanceStatusEnum } from './BatchClearanceStatusEnum';
import { operatorId } from './Operator';
import { calendarDate } from '../../calendar-date';
import { harvestBranchId } from './HarvestBranch';
import { z } from 'zod';
export const brewBatchId = (z.number());
export const brewBatch = z.object({
    id: brewBatchId,
    harvest_id: harvestId,
    source_harvest_operation_id: harvestOperationId,
    harvest_protocol_op_batch_definition_id: harvestProtocolOpBatchDefinitionId.nullable(),
    name: z.string(),
    description: z.string().nullable(),
    batch_type: batchTypeEnum,
    batch_number: z.string().nullable(),
    actual_weight_kg: z.string().nullable(),
    actual_volume_l: z.string().nullable(),
    storage_location_id: invLocationId.nullable(),
    storage_requirements: z.string().nullable(),
    status: batchStatusEnum,
    clearance_definition_id: batchClearanceDefinitionId.nullable(),
    clearance_status: batchClearanceStatusEnum,
    clearance_decision_reason: z.string().nullable(),
    clearance_notes: z.string().nullable(),
    clearance_decided_by_operator_id: operatorId.nullable(),
    clearance_decided_at: z.date().nullable(),
    produced_at: z.date().nullable(),
    stored_at: z.date().nullable(),
    expiry_date: calendarDate.nullable(),
    released_at: z.date().nullable(),
    disposed_at: z.date().nullable(),
    produced_by: operatorId.nullable(),
    responsible_operator_id: operatorId.nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    safe_packaging_practice_checked: z.boolean().nullable(),
    safe_packaging_practice_notes: z.string().nullable(),
    foreign_object_check_passed: z.boolean().nullable(),
    foreign_object_check_notes: z.string().nullable(),
    clearance_responsible_operator_id: operatorId.nullable(),
    name_scheme: z.string(),
    branch_id: harvestBranchId.nullable(),
});
export const brewBatchInitializer = z.object({
    id: brewBatchId.optional(),
    harvest_id: harvestId,
    source_harvest_operation_id: harvestOperationId,
    harvest_protocol_op_batch_definition_id: harvestProtocolOpBatchDefinitionId.optional().nullable(),
    name: z.string(),
    description: z.string().optional().nullable(),
    batch_type: batchTypeEnum,
    batch_number: z.string().optional().nullable(),
    actual_weight_kg: z.string().optional().nullable(),
    actual_volume_l: z.string().optional().nullable(),
    storage_location_id: invLocationId.optional().nullable(),
    storage_requirements: z.string().optional().nullable(),
    status: batchStatusEnum.optional(),
    clearance_definition_id: batchClearanceDefinitionId.optional().nullable(),
    clearance_status: batchClearanceStatusEnum.optional(),
    clearance_decision_reason: z.string().optional().nullable(),
    clearance_notes: z.string().optional().nullable(),
    clearance_decided_by_operator_id: operatorId.optional().nullable(),
    clearance_decided_at: z.date().optional().nullable(),
    produced_at: z.date().optional().nullable(),
    stored_at: z.date().optional().nullable(),
    expiry_date: calendarDate.optional().nullable(),
    released_at: z.date().optional().nullable(),
    disposed_at: z.date().optional().nullable(),
    produced_by: operatorId.optional().nullable(),
    responsible_operator_id: operatorId.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    safe_packaging_practice_checked: z.boolean().optional().nullable(),
    safe_packaging_practice_notes: z.string().optional().nullable(),
    foreign_object_check_passed: z.boolean().optional().nullable(),
    foreign_object_check_notes: z.string().optional().nullable(),
    clearance_responsible_operator_id: operatorId.optional().nullable(),
    name_scheme: z.string().optional(),
    branch_id: harvestBranchId.optional().nullable(),
});
export const brewBatchMutator = z.object({
    id: brewBatchId.optional(),
    harvest_id: harvestId.optional(),
    source_harvest_operation_id: harvestOperationId.optional(),
    harvest_protocol_op_batch_definition_id: harvestProtocolOpBatchDefinitionId.optional().nullable(),
    name: z.string().optional(),
    description: z.string().optional().nullable(),
    batch_type: batchTypeEnum.optional(),
    batch_number: z.string().optional().nullable(),
    actual_weight_kg: z.string().optional().nullable(),
    actual_volume_l: z.string().optional().nullable(),
    storage_location_id: invLocationId.optional().nullable(),
    storage_requirements: z.string().optional().nullable(),
    status: batchStatusEnum.optional(),
    clearance_definition_id: batchClearanceDefinitionId.optional().nullable(),
    clearance_status: batchClearanceStatusEnum.optional(),
    clearance_decision_reason: z.string().optional().nullable(),
    clearance_notes: z.string().optional().nullable(),
    clearance_decided_by_operator_id: operatorId.optional().nullable(),
    clearance_decided_at: z.date().optional().nullable(),
    produced_at: z.date().optional().nullable(),
    stored_at: z.date().optional().nullable(),
    expiry_date: calendarDate.optional().nullable(),
    released_at: z.date().optional().nullable(),
    disposed_at: z.date().optional().nullable(),
    produced_by: operatorId.optional().nullable(),
    responsible_operator_id: operatorId.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    safe_packaging_practice_checked: z.boolean().optional().nullable(),
    safe_packaging_practice_notes: z.string().optional().nullable(),
    foreign_object_check_passed: z.boolean().optional().nullable(),
    foreign_object_check_notes: z.string().optional().nullable(),
    clearance_responsible_operator_id: operatorId.optional().nullable(),
    name_scheme: z.string().optional(),
    branch_id: harvestBranchId.optional().nullable(),
});
//# sourceMappingURL=BrewBatch.js.map